// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: trading-bridge.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import { Params } from "./common";
import { Empty } from "./google/protobuf/empty";
import {
  Broker_OrderType,
  broker_OrderTypeFromJSON,
  broker_OrderTypeToJSON,
  Broker_Variety,
  broker_VarietyFromJSON,
  broker_VarietyToJSON,
  MarginFromBrokerRequest,
  MarginFromBrokerResponse,
  Order,
  Orders,
  Product,
  productFromJSON,
  productToJSON,
  Trade,
  TransactionType,
  transactionTypeFromJSON,
  transactionTypeToJSON,
  Validity,
  validityFromJSON,
  validityToJSON,
} from "./order";
import { Position as Position1 } from "./position";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.tradingbridge";

export enum TradingAccountStatus {
  STATUS_UNKNOWN = 0,
  ACTIVE = 1,
  BROKEN = 2,
  SYNC_PENDING = 3,
  SYNC_IN_PROGRESS = 5,
  SYNC_FAILED = 6,
  UNRECOGNIZED = -1,
}

export function tradingAccountStatusFromJSON(object: any): TradingAccountStatus {
  switch (object) {
    case 0:
    case "STATUS_UNKNOWN":
      return TradingAccountStatus.STATUS_UNKNOWN;
    case 1:
    case "ACTIVE":
      return TradingAccountStatus.ACTIVE;
    case 2:
    case "BROKEN":
      return TradingAccountStatus.BROKEN;
    case 3:
    case "SYNC_PENDING":
      return TradingAccountStatus.SYNC_PENDING;
    case 5:
    case "SYNC_IN_PROGRESS":
      return TradingAccountStatus.SYNC_IN_PROGRESS;
    case 6:
    case "SYNC_FAILED":
      return TradingAccountStatus.SYNC_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TradingAccountStatus.UNRECOGNIZED;
  }
}

export function tradingAccountStatusToJSON(object: TradingAccountStatus): string {
  switch (object) {
    case TradingAccountStatus.STATUS_UNKNOWN:
      return "STATUS_UNKNOWN";
    case TradingAccountStatus.ACTIVE:
      return "ACTIVE";
    case TradingAccountStatus.BROKEN:
      return "BROKEN";
    case TradingAccountStatus.SYNC_PENDING:
      return "SYNC_PENDING";
    case TradingAccountStatus.SYNC_IN_PROGRESS:
      return "SYNC_IN_PROGRESS";
    case TradingAccountStatus.SYNC_FAILED:
      return "SYNC_FAILED";
    case TradingAccountStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Broker {
  code: string;
  name: string;
  enabled: boolean;
  syncAvailable: boolean;
  priority: number;
  imageUrl: string;
  orderHistorySupported: boolean;
  shortCode: string;
}

export interface Brokers {
  brokers: Broker[];
}

export interface GetBrokersRequest {
}

export interface GetBrokerLoginUrlRequest {
  brokerCode: string;
  params: Params[];
}

export interface GetBrokerLoginUrlResponse {
  brokerCode: string;
  loginUrl: string;
  params: Params[];
}

export interface ConnectTradingAccountRequest {
  brokerCode: string;
  tradingAccountId: string;
  tradingAccountParameters: TradingAccount_TradingAccountParameter[];
}

export interface ChangePrimaryTradingAccountRequest {
  tradingAccountId: string;
}

export interface ConnectTradingAccountResponse {
  tradingAccount: TradingAccount | undefined;
}

export interface RemoveTradingAccountRequest {
  brokerCode: string;
  tradingAccountId: string;
}

export interface TradingAccounts {
  tradingAccounts: TradingAccount[];
}

export interface TradingAccount {
  accountId: string;
  displayName: string;
  brokerCode: string;
  brokerAccountId: string;
  status: TradingAccountStatus;
  created: number;
  exchanges: string[];
  products: string[];
  orderTypes: string[];
  tradingAccountParameters: TradingAccount_TradingAccountParameter[];
  primary: boolean;
  debugEnabled: boolean;
}

export interface TradingAccount_TradingAccountParameter {
  parameterName: string;
  parameterValue: string;
}

export interface GetUsersForTradingAccountRequest {
  tradingAccountId: string;
}

export interface SetDebugForTradingAccountRequest {
  tradingAccountId: string;
  debugMode: boolean;
}

export interface GetUsersForTradingAccountResponse {
  userIds: string[];
}

export interface GetTradingAccountMarginRequest {
  accountId: string;
}

export interface RefreshTradingAccountRequest {
  accountId: string;
}

export interface TradingAccountMargins {
  tradingAccountMargins: TradingAccountMargin[];
}

export interface TradingAccountMargin {
  accountId: string;
  marginAvailable: number;
  marginUsed: number;
  cashAvailable: number;
}

export interface SuccessfulBrokerAuthResponse {
  userId: string;
  brokerCode: string;
  brokerAccountId: string;
  exchanges: string[];
  products: string[];
  orderTypes: string[];
  tradingAccountParameters: TradingAccount_TradingAccountParameter[];
}

export interface PlaceOrModifyOrdersRequest {
  tradingAccountId: string;
  order: Order[];
  buyBeforeSell: boolean;
}

export interface PlaceOrModifyOrdersResponse {
  orderResponse: OrderResponse[];
}

export interface CancelOrdersRequest {
  tradingAccountId: string;
  orderId: string[];
}

export interface CancelOrdersResponse {
  orderResponse: OrderResponse[];
}

export interface OrderResponse {
  successful: boolean;
  clientOrderId: string;
  orderId: string;
  brokerOrderId: string;
  errorMessage: string;
  commitOrder: boolean;
  order: Order | undefined;
}

export interface GetOrderRequest {
  accountId: string;
  orderId: string;
}

export interface GetAllOrdersRequest {
  tradingAccountId: string;
}

export interface TradingAccountSyncRequest {
  tradingAccountId: string;
  types: TradingAccountSyncRequest_Type[];
  force: boolean;
}

export enum TradingAccountSyncRequest_Type {
  TYPE_UNKNOWN = 0,
  ORDER_SYNC = 1,
  MARGIN_SYNC = 2,
  POSITION_SYNC = 3,
  SETTLE_DAY_END_POSITIONS = 4,
  DAY_START_POSITION_RECONCILIATION = 5,
  UNRECOGNIZED = -1,
}

export function tradingAccountSyncRequest_TypeFromJSON(object: any): TradingAccountSyncRequest_Type {
  switch (object) {
    case 0:
    case "TYPE_UNKNOWN":
      return TradingAccountSyncRequest_Type.TYPE_UNKNOWN;
    case 1:
    case "ORDER_SYNC":
      return TradingAccountSyncRequest_Type.ORDER_SYNC;
    case 2:
    case "MARGIN_SYNC":
      return TradingAccountSyncRequest_Type.MARGIN_SYNC;
    case 3:
    case "POSITION_SYNC":
      return TradingAccountSyncRequest_Type.POSITION_SYNC;
    case 4:
    case "SETTLE_DAY_END_POSITIONS":
      return TradingAccountSyncRequest_Type.SETTLE_DAY_END_POSITIONS;
    case 5:
    case "DAY_START_POSITION_RECONCILIATION":
      return TradingAccountSyncRequest_Type.DAY_START_POSITION_RECONCILIATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TradingAccountSyncRequest_Type.UNRECOGNIZED;
  }
}

export function tradingAccountSyncRequest_TypeToJSON(object: TradingAccountSyncRequest_Type): string {
  switch (object) {
    case TradingAccountSyncRequest_Type.TYPE_UNKNOWN:
      return "TYPE_UNKNOWN";
    case TradingAccountSyncRequest_Type.ORDER_SYNC:
      return "ORDER_SYNC";
    case TradingAccountSyncRequest_Type.MARGIN_SYNC:
      return "MARGIN_SYNC";
    case TradingAccountSyncRequest_Type.POSITION_SYNC:
      return "POSITION_SYNC";
    case TradingAccountSyncRequest_Type.SETTLE_DAY_END_POSITIONS:
      return "SETTLE_DAY_END_POSITIONS";
    case TradingAccountSyncRequest_Type.DAY_START_POSITION_RECONCILIATION:
      return "DAY_START_POSITION_RECONCILIATION";
    case TradingAccountSyncRequest_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TradingAccountUpdate {
  userId: string;
  tradingAccountId: string;
  orders: Order[];
  positions: Position1[];
  margin: TradingAccountMargin | undefined;
}

export interface Position {
  security: Security | undefined;
  product: Product;
  quantity: number;
  overnightQuantity: number;
  overnightValue: number;
  buyQuantity: number;
  sellQuantity: number;
  buyValue: number;
  sellValue: number;
  dayBuyQuantity: number;
  dayBuyValue: number;
  daySellQuantity: number;
  daySellValue: number;
}

export interface GetTradingAccountPnlRequest {
  accountId: string;
}

export interface TradingAccountPnl {
  accountId: string;
  dayProfit: number;
  monthProfit: number;
}

export interface GetHoldingsRequest {
  accountId: string;
}

export interface GetHoldingsResponse {
  holdings: Holding[];
}

export interface Holding {
  security: Security | undefined;
  quantity: number;
  averageBuyPrice: number;
  t1Quantity: number;
}

export interface GetOrderHistoryRequest {
  accountId: string;
  orderId: string;
}

export interface GetOrderHistoryResponse {
  orders: OrderHistory[];
}

export interface OrderHistory {
  clientOrderId: string;
  orderId: string;
  brokerOrderId: string;
  exchangeOrderId: string;
  security: Security | undefined;
  transactionType: TransactionType;
  orderType: Broker_OrderType;
  quantity: number;
  product: Product;
  price: number;
  triggerPrice: number;
  variety: Broker_Variety;
  disclosedQuantity: number;
  validity: Validity;
  status: string;
  filledQuantity: number;
  unfilledQuantity: number;
  averageTradedPrice: number;
  secondaryStatus: string;
  exchangeTimestamp: number;
  message: string;
}

export interface GetOrderTradeHistoryRequest {
  accountId: string;
  orderId: string;
}

export interface GetOrderTradeHistoryResponse {
  trades: Trade[];
}

function createBaseBroker(): Broker {
  return {
    code: "",
    name: "",
    enabled: false,
    syncAvailable: false,
    priority: 0,
    imageUrl: "",
    orderHistorySupported: false,
    shortCode: "",
  };
}

export const Broker = {
  encode(message: Broker, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(24).bool(message.enabled);
    }
    if (message.syncAvailable !== false) {
      writer.uint32(32).bool(message.syncAvailable);
    }
    if (message.priority !== 0) {
      writer.uint32(48).int32(message.priority);
    }
    if (message.imageUrl !== "") {
      writer.uint32(58).string(message.imageUrl);
    }
    if (message.orderHistorySupported !== false) {
      writer.uint32(64).bool(message.orderHistorySupported);
    }
    if (message.shortCode !== "") {
      writer.uint32(74).string(message.shortCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Broker {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBroker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.syncAvailable = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.priority = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.imageUrl = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.orderHistorySupported = reader.bool();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.shortCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Broker {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      syncAvailable: isSet(object.syncAvailable) ? globalThis.Boolean(object.syncAvailable) : false,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      imageUrl: isSet(object.imageUrl) ? globalThis.String(object.imageUrl) : "",
      orderHistorySupported: isSet(object.orderHistorySupported)
        ? globalThis.Boolean(object.orderHistorySupported)
        : false,
      shortCode: isSet(object.shortCode) ? globalThis.String(object.shortCode) : "",
    };
  },

  toJSON(message: Broker): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.syncAvailable !== false) {
      obj.syncAvailable = message.syncAvailable;
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.imageUrl !== "") {
      obj.imageUrl = message.imageUrl;
    }
    if (message.orderHistorySupported !== false) {
      obj.orderHistorySupported = message.orderHistorySupported;
    }
    if (message.shortCode !== "") {
      obj.shortCode = message.shortCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Broker>, I>>(base?: I): Broker {
    return Broker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Broker>, I>>(object: I): Broker {
    const message = createBaseBroker();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    message.syncAvailable = object.syncAvailable ?? false;
    message.priority = object.priority ?? 0;
    message.imageUrl = object.imageUrl ?? "";
    message.orderHistorySupported = object.orderHistorySupported ?? false;
    message.shortCode = object.shortCode ?? "";
    return message;
  },
};

function createBaseBrokers(): Brokers {
  return { brokers: [] };
}

export const Brokers = {
  encode(message: Brokers, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.brokers) {
      Broker.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Brokers {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBrokers();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.brokers.push(Broker.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Brokers {
    return {
      brokers: globalThis.Array.isArray(object?.brokers) ? object.brokers.map((e: any) => Broker.fromJSON(e)) : [],
    };
  },

  toJSON(message: Brokers): unknown {
    const obj: any = {};
    if (message.brokers?.length) {
      obj.brokers = message.brokers.map((e) => Broker.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Brokers>, I>>(base?: I): Brokers {
    return Brokers.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Brokers>, I>>(object: I): Brokers {
    const message = createBaseBrokers();
    message.brokers = object.brokers?.map((e) => Broker.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetBrokersRequest(): GetBrokersRequest {
  return {};
}

export const GetBrokersRequest = {
  encode(_: GetBrokersRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetBrokersRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBrokersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetBrokersRequest {
    return {};
  },

  toJSON(_: GetBrokersRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBrokersRequest>, I>>(base?: I): GetBrokersRequest {
    return GetBrokersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBrokersRequest>, I>>(_: I): GetBrokersRequest {
    const message = createBaseGetBrokersRequest();
    return message;
  },
};

function createBaseGetBrokerLoginUrlRequest(): GetBrokerLoginUrlRequest {
  return { brokerCode: "", params: [] };
}

export const GetBrokerLoginUrlRequest = {
  encode(message: GetBrokerLoginUrlRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.brokerCode !== "") {
      writer.uint32(10).string(message.brokerCode);
    }
    for (const v of message.params) {
      Params.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetBrokerLoginUrlRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBrokerLoginUrlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.brokerCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.params.push(Params.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBrokerLoginUrlRequest {
    return {
      brokerCode: isSet(object.brokerCode) ? globalThis.String(object.brokerCode) : "",
      params: globalThis.Array.isArray(object?.params) ? object.params.map((e: any) => Params.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetBrokerLoginUrlRequest): unknown {
    const obj: any = {};
    if (message.brokerCode !== "") {
      obj.brokerCode = message.brokerCode;
    }
    if (message.params?.length) {
      obj.params = message.params.map((e) => Params.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBrokerLoginUrlRequest>, I>>(base?: I): GetBrokerLoginUrlRequest {
    return GetBrokerLoginUrlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBrokerLoginUrlRequest>, I>>(object: I): GetBrokerLoginUrlRequest {
    const message = createBaseGetBrokerLoginUrlRequest();
    message.brokerCode = object.brokerCode ?? "";
    message.params = object.params?.map((e) => Params.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetBrokerLoginUrlResponse(): GetBrokerLoginUrlResponse {
  return { brokerCode: "", loginUrl: "", params: [] };
}

export const GetBrokerLoginUrlResponse = {
  encode(message: GetBrokerLoginUrlResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.brokerCode !== "") {
      writer.uint32(10).string(message.brokerCode);
    }
    if (message.loginUrl !== "") {
      writer.uint32(18).string(message.loginUrl);
    }
    for (const v of message.params) {
      Params.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetBrokerLoginUrlResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBrokerLoginUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.brokerCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.loginUrl = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.params.push(Params.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBrokerLoginUrlResponse {
    return {
      brokerCode: isSet(object.brokerCode) ? globalThis.String(object.brokerCode) : "",
      loginUrl: isSet(object.loginUrl) ? globalThis.String(object.loginUrl) : "",
      params: globalThis.Array.isArray(object?.params) ? object.params.map((e: any) => Params.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetBrokerLoginUrlResponse): unknown {
    const obj: any = {};
    if (message.brokerCode !== "") {
      obj.brokerCode = message.brokerCode;
    }
    if (message.loginUrl !== "") {
      obj.loginUrl = message.loginUrl;
    }
    if (message.params?.length) {
      obj.params = message.params.map((e) => Params.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBrokerLoginUrlResponse>, I>>(base?: I): GetBrokerLoginUrlResponse {
    return GetBrokerLoginUrlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBrokerLoginUrlResponse>, I>>(object: I): GetBrokerLoginUrlResponse {
    const message = createBaseGetBrokerLoginUrlResponse();
    message.brokerCode = object.brokerCode ?? "";
    message.loginUrl = object.loginUrl ?? "";
    message.params = object.params?.map((e) => Params.fromPartial(e)) || [];
    return message;
  },
};

function createBaseConnectTradingAccountRequest(): ConnectTradingAccountRequest {
  return { brokerCode: "", tradingAccountId: "", tradingAccountParameters: [] };
}

export const ConnectTradingAccountRequest = {
  encode(message: ConnectTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.brokerCode !== "") {
      writer.uint32(10).string(message.brokerCode);
    }
    if (message.tradingAccountId !== "") {
      writer.uint32(18).string(message.tradingAccountId);
    }
    for (const v of message.tradingAccountParameters) {
      TradingAccount_TradingAccountParameter.encode(v!, writer.uint32(66).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConnectTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.brokerCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.tradingAccountParameters.push(TradingAccount_TradingAccountParameter.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConnectTradingAccountRequest {
    return {
      brokerCode: isSet(object.brokerCode) ? globalThis.String(object.brokerCode) : "",
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      tradingAccountParameters: globalThis.Array.isArray(object?.tradingAccountParameters)
        ? object.tradingAccountParameters.map((e: any) => TradingAccount_TradingAccountParameter.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ConnectTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.brokerCode !== "") {
      obj.brokerCode = message.brokerCode;
    }
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.tradingAccountParameters?.length) {
      obj.tradingAccountParameters = message.tradingAccountParameters.map((e) =>
        TradingAccount_TradingAccountParameter.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConnectTradingAccountRequest>, I>>(base?: I): ConnectTradingAccountRequest {
    return ConnectTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConnectTradingAccountRequest>, I>>(object: I): ConnectTradingAccountRequest {
    const message = createBaseConnectTradingAccountRequest();
    message.brokerCode = object.brokerCode ?? "";
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.tradingAccountParameters =
      object.tradingAccountParameters?.map((e) => TradingAccount_TradingAccountParameter.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChangePrimaryTradingAccountRequest(): ChangePrimaryTradingAccountRequest {
  return { tradingAccountId: "" };
}

export const ChangePrimaryTradingAccountRequest = {
  encode(message: ChangePrimaryTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChangePrimaryTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChangePrimaryTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChangePrimaryTradingAccountRequest {
    return { tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "" };
  },

  toJSON(message: ChangePrimaryTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChangePrimaryTradingAccountRequest>, I>>(
    base?: I,
  ): ChangePrimaryTradingAccountRequest {
    return ChangePrimaryTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChangePrimaryTradingAccountRequest>, I>>(
    object: I,
  ): ChangePrimaryTradingAccountRequest {
    const message = createBaseChangePrimaryTradingAccountRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBaseConnectTradingAccountResponse(): ConnectTradingAccountResponse {
  return { tradingAccount: undefined };
}

export const ConnectTradingAccountResponse = {
  encode(message: ConnectTradingAccountResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccount !== undefined) {
      TradingAccount.encode(message.tradingAccount, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConnectTradingAccountResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectTradingAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccount = TradingAccount.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConnectTradingAccountResponse {
    return {
      tradingAccount: isSet(object.tradingAccount) ? TradingAccount.fromJSON(object.tradingAccount) : undefined,
    };
  },

  toJSON(message: ConnectTradingAccountResponse): unknown {
    const obj: any = {};
    if (message.tradingAccount !== undefined) {
      obj.tradingAccount = TradingAccount.toJSON(message.tradingAccount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConnectTradingAccountResponse>, I>>(base?: I): ConnectTradingAccountResponse {
    return ConnectTradingAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConnectTradingAccountResponse>, I>>(
    object: I,
  ): ConnectTradingAccountResponse {
    const message = createBaseConnectTradingAccountResponse();
    message.tradingAccount = (object.tradingAccount !== undefined && object.tradingAccount !== null)
      ? TradingAccount.fromPartial(object.tradingAccount)
      : undefined;
    return message;
  },
};

function createBaseRemoveTradingAccountRequest(): RemoveTradingAccountRequest {
  return { brokerCode: "", tradingAccountId: "" };
}

export const RemoveTradingAccountRequest = {
  encode(message: RemoveTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.brokerCode !== "") {
      writer.uint32(10).string(message.brokerCode);
    }
    if (message.tradingAccountId !== "") {
      writer.uint32(18).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemoveTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.brokerCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveTradingAccountRequest {
    return {
      brokerCode: isSet(object.brokerCode) ? globalThis.String(object.brokerCode) : "",
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
    };
  },

  toJSON(message: RemoveTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.brokerCode !== "") {
      obj.brokerCode = message.brokerCode;
    }
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveTradingAccountRequest>, I>>(base?: I): RemoveTradingAccountRequest {
    return RemoveTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveTradingAccountRequest>, I>>(object: I): RemoveTradingAccountRequest {
    const message = createBaseRemoveTradingAccountRequest();
    message.brokerCode = object.brokerCode ?? "";
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBaseTradingAccounts(): TradingAccounts {
  return { tradingAccounts: [] };
}

export const TradingAccounts = {
  encode(message: TradingAccounts, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.tradingAccounts) {
      TradingAccount.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccounts {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccounts.push(TradingAccount.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccounts {
    return {
      tradingAccounts: globalThis.Array.isArray(object?.tradingAccounts)
        ? object.tradingAccounts.map((e: any) => TradingAccount.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TradingAccounts): unknown {
    const obj: any = {};
    if (message.tradingAccounts?.length) {
      obj.tradingAccounts = message.tradingAccounts.map((e) => TradingAccount.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccounts>, I>>(base?: I): TradingAccounts {
    return TradingAccounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccounts>, I>>(object: I): TradingAccounts {
    const message = createBaseTradingAccounts();
    message.tradingAccounts = object.tradingAccounts?.map((e) => TradingAccount.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTradingAccount(): TradingAccount {
  return {
    accountId: "",
    displayName: "",
    brokerCode: "",
    brokerAccountId: "",
    status: 0,
    created: 0,
    exchanges: [],
    products: [],
    orderTypes: [],
    tradingAccountParameters: [],
    primary: false,
    debugEnabled: false,
  };
}

export const TradingAccount = {
  encode(message: TradingAccount, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    if (message.brokerCode !== "") {
      writer.uint32(26).string(message.brokerCode);
    }
    if (message.brokerAccountId !== "") {
      writer.uint32(42).string(message.brokerAccountId);
    }
    if (message.status !== 0) {
      writer.uint32(56).int32(message.status);
    }
    if (message.created !== 0) {
      writer.uint32(72).int64(message.created);
    }
    for (const v of message.exchanges) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.products) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.orderTypes) {
      writer.uint32(98).string(v!);
    }
    for (const v of message.tradingAccountParameters) {
      TradingAccount_TradingAccountParameter.encode(v!, writer.uint32(122).fork()).ldelim();
    }
    if (message.primary !== false) {
      writer.uint32(144).bool(message.primary);
    }
    if (message.debugEnabled !== false) {
      writer.uint32(152).bool(message.debugEnabled);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccount {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.brokerCode = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.brokerAccountId = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.created = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.exchanges.push(reader.string());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.products.push(reader.string());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.orderTypes.push(reader.string());
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.tradingAccountParameters.push(TradingAccount_TradingAccountParameter.decode(reader, reader.uint32()));
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.primary = reader.bool();
          continue;
        case 19:
          if (tag !== 152) {
            break;
          }

          message.debugEnabled = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccount {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      brokerCode: isSet(object.brokerCode) ? globalThis.String(object.brokerCode) : "",
      brokerAccountId: isSet(object.brokerAccountId) ? globalThis.String(object.brokerAccountId) : "",
      status: isSet(object.status) ? tradingAccountStatusFromJSON(object.status) : 0,
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
      exchanges: globalThis.Array.isArray(object?.exchanges)
        ? object.exchanges.map((e: any) => globalThis.String(e))
        : [],
      products: globalThis.Array.isArray(object?.products) ? object.products.map((e: any) => globalThis.String(e)) : [],
      orderTypes: globalThis.Array.isArray(object?.orderTypes)
        ? object.orderTypes.map((e: any) => globalThis.String(e))
        : [],
      tradingAccountParameters: globalThis.Array.isArray(object?.tradingAccountParameters)
        ? object.tradingAccountParameters.map((e: any) => TradingAccount_TradingAccountParameter.fromJSON(e))
        : [],
      primary: isSet(object.primary) ? globalThis.Boolean(object.primary) : false,
      debugEnabled: isSet(object.debugEnabled) ? globalThis.Boolean(object.debugEnabled) : false,
    };
  },

  toJSON(message: TradingAccount): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.brokerCode !== "") {
      obj.brokerCode = message.brokerCode;
    }
    if (message.brokerAccountId !== "") {
      obj.brokerAccountId = message.brokerAccountId;
    }
    if (message.status !== 0) {
      obj.status = tradingAccountStatusToJSON(message.status);
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    if (message.exchanges?.length) {
      obj.exchanges = message.exchanges;
    }
    if (message.products?.length) {
      obj.products = message.products;
    }
    if (message.orderTypes?.length) {
      obj.orderTypes = message.orderTypes;
    }
    if (message.tradingAccountParameters?.length) {
      obj.tradingAccountParameters = message.tradingAccountParameters.map((e) =>
        TradingAccount_TradingAccountParameter.toJSON(e)
      );
    }
    if (message.primary !== false) {
      obj.primary = message.primary;
    }
    if (message.debugEnabled !== false) {
      obj.debugEnabled = message.debugEnabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccount>, I>>(base?: I): TradingAccount {
    return TradingAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccount>, I>>(object: I): TradingAccount {
    const message = createBaseTradingAccount();
    message.accountId = object.accountId ?? "";
    message.displayName = object.displayName ?? "";
    message.brokerCode = object.brokerCode ?? "";
    message.brokerAccountId = object.brokerAccountId ?? "";
    message.status = object.status ?? 0;
    message.created = object.created ?? 0;
    message.exchanges = object.exchanges?.map((e) => e) || [];
    message.products = object.products?.map((e) => e) || [];
    message.orderTypes = object.orderTypes?.map((e) => e) || [];
    message.tradingAccountParameters =
      object.tradingAccountParameters?.map((e) => TradingAccount_TradingAccountParameter.fromPartial(e)) || [];
    message.primary = object.primary ?? false;
    message.debugEnabled = object.debugEnabled ?? false;
    return message;
  },
};

function createBaseTradingAccount_TradingAccountParameter(): TradingAccount_TradingAccountParameter {
  return { parameterName: "", parameterValue: "" };
}

export const TradingAccount_TradingAccountParameter = {
  encode(message: TradingAccount_TradingAccountParameter, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.parameterName !== "") {
      writer.uint32(10).string(message.parameterName);
    }
    if (message.parameterValue !== "") {
      writer.uint32(18).string(message.parameterValue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccount_TradingAccountParameter {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccount_TradingAccountParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.parameterName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.parameterValue = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccount_TradingAccountParameter {
    return {
      parameterName: isSet(object.parameterName) ? globalThis.String(object.parameterName) : "",
      parameterValue: isSet(object.parameterValue) ? globalThis.String(object.parameterValue) : "",
    };
  },

  toJSON(message: TradingAccount_TradingAccountParameter): unknown {
    const obj: any = {};
    if (message.parameterName !== "") {
      obj.parameterName = message.parameterName;
    }
    if (message.parameterValue !== "") {
      obj.parameterValue = message.parameterValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccount_TradingAccountParameter>, I>>(
    base?: I,
  ): TradingAccount_TradingAccountParameter {
    return TradingAccount_TradingAccountParameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccount_TradingAccountParameter>, I>>(
    object: I,
  ): TradingAccount_TradingAccountParameter {
    const message = createBaseTradingAccount_TradingAccountParameter();
    message.parameterName = object.parameterName ?? "";
    message.parameterValue = object.parameterValue ?? "";
    return message;
  },
};

function createBaseGetUsersForTradingAccountRequest(): GetUsersForTradingAccountRequest {
  return { tradingAccountId: "" };
}

export const GetUsersForTradingAccountRequest = {
  encode(message: GetUsersForTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetUsersForTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUsersForTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUsersForTradingAccountRequest {
    return { tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "" };
  },

  toJSON(message: GetUsersForTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUsersForTradingAccountRequest>, I>>(
    base?: I,
  ): GetUsersForTradingAccountRequest {
    return GetUsersForTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUsersForTradingAccountRequest>, I>>(
    object: I,
  ): GetUsersForTradingAccountRequest {
    const message = createBaseGetUsersForTradingAccountRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBaseSetDebugForTradingAccountRequest(): SetDebugForTradingAccountRequest {
  return { tradingAccountId: "", debugMode: false };
}

export const SetDebugForTradingAccountRequest = {
  encode(message: SetDebugForTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    if (message.debugMode !== false) {
      writer.uint32(16).bool(message.debugMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetDebugForTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDebugForTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.debugMode = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetDebugForTradingAccountRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      debugMode: isSet(object.debugMode) ? globalThis.Boolean(object.debugMode) : false,
    };
  },

  toJSON(message: SetDebugForTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.debugMode !== false) {
      obj.debugMode = message.debugMode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDebugForTradingAccountRequest>, I>>(
    base?: I,
  ): SetDebugForTradingAccountRequest {
    return SetDebugForTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDebugForTradingAccountRequest>, I>>(
    object: I,
  ): SetDebugForTradingAccountRequest {
    const message = createBaseSetDebugForTradingAccountRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.debugMode = object.debugMode ?? false;
    return message;
  },
};

function createBaseGetUsersForTradingAccountResponse(): GetUsersForTradingAccountResponse {
  return { userIds: [] };
}

export const GetUsersForTradingAccountResponse = {
  encode(message: GetUsersForTradingAccountResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.userIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetUsersForTradingAccountResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUsersForTradingAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userIds.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUsersForTradingAccountResponse {
    return {
      userIds: globalThis.Array.isArray(object?.userIds) ? object.userIds.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetUsersForTradingAccountResponse): unknown {
    const obj: any = {};
    if (message.userIds?.length) {
      obj.userIds = message.userIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUsersForTradingAccountResponse>, I>>(
    base?: I,
  ): GetUsersForTradingAccountResponse {
    return GetUsersForTradingAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUsersForTradingAccountResponse>, I>>(
    object: I,
  ): GetUsersForTradingAccountResponse {
    const message = createBaseGetUsersForTradingAccountResponse();
    message.userIds = object.userIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetTradingAccountMarginRequest(): GetTradingAccountMarginRequest {
  return { accountId: "" };
}

export const GetTradingAccountMarginRequest = {
  encode(message: GetTradingAccountMarginRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTradingAccountMarginRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTradingAccountMarginRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTradingAccountMarginRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: GetTradingAccountMarginRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTradingAccountMarginRequest>, I>>(base?: I): GetTradingAccountMarginRequest {
    return GetTradingAccountMarginRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTradingAccountMarginRequest>, I>>(
    object: I,
  ): GetTradingAccountMarginRequest {
    const message = createBaseGetTradingAccountMarginRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseRefreshTradingAccountRequest(): RefreshTradingAccountRequest {
  return { accountId: "" };
}

export const RefreshTradingAccountRequest = {
  encode(message: RefreshTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RefreshTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRefreshTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RefreshTradingAccountRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: RefreshTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RefreshTradingAccountRequest>, I>>(base?: I): RefreshTradingAccountRequest {
    return RefreshTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RefreshTradingAccountRequest>, I>>(object: I): RefreshTradingAccountRequest {
    const message = createBaseRefreshTradingAccountRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseTradingAccountMargins(): TradingAccountMargins {
  return { tradingAccountMargins: [] };
}

export const TradingAccountMargins = {
  encode(message: TradingAccountMargins, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.tradingAccountMargins) {
      TradingAccountMargin.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountMargins {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountMargins();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountMargins.push(TradingAccountMargin.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountMargins {
    return {
      tradingAccountMargins: globalThis.Array.isArray(object?.tradingAccountMargins)
        ? object.tradingAccountMargins.map((e: any) => TradingAccountMargin.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TradingAccountMargins): unknown {
    const obj: any = {};
    if (message.tradingAccountMargins?.length) {
      obj.tradingAccountMargins = message.tradingAccountMargins.map((e) => TradingAccountMargin.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountMargins>, I>>(base?: I): TradingAccountMargins {
    return TradingAccountMargins.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountMargins>, I>>(object: I): TradingAccountMargins {
    const message = createBaseTradingAccountMargins();
    message.tradingAccountMargins = object.tradingAccountMargins?.map((e) => TradingAccountMargin.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTradingAccountMargin(): TradingAccountMargin {
  return { accountId: "", marginAvailable: 0, marginUsed: 0, cashAvailable: 0 };
}

export const TradingAccountMargin = {
  encode(message: TradingAccountMargin, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    if (message.marginAvailable !== 0) {
      writer.uint32(33).double(message.marginAvailable);
    }
    if (message.marginUsed !== 0) {
      writer.uint32(49).double(message.marginUsed);
    }
    if (message.cashAvailable !== 0) {
      writer.uint32(65).double(message.cashAvailable);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountMargin {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountMargin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.marginAvailable = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.marginUsed = reader.double();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.cashAvailable = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountMargin {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      marginAvailable: isSet(object.marginAvailable) ? globalThis.Number(object.marginAvailable) : 0,
      marginUsed: isSet(object.marginUsed) ? globalThis.Number(object.marginUsed) : 0,
      cashAvailable: isSet(object.cashAvailable) ? globalThis.Number(object.cashAvailable) : 0,
    };
  },

  toJSON(message: TradingAccountMargin): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.marginAvailable !== 0) {
      obj.marginAvailable = message.marginAvailable;
    }
    if (message.marginUsed !== 0) {
      obj.marginUsed = message.marginUsed;
    }
    if (message.cashAvailable !== 0) {
      obj.cashAvailable = message.cashAvailable;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountMargin>, I>>(base?: I): TradingAccountMargin {
    return TradingAccountMargin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountMargin>, I>>(object: I): TradingAccountMargin {
    const message = createBaseTradingAccountMargin();
    message.accountId = object.accountId ?? "";
    message.marginAvailable = object.marginAvailable ?? 0;
    message.marginUsed = object.marginUsed ?? 0;
    message.cashAvailable = object.cashAvailable ?? 0;
    return message;
  },
};

function createBaseSuccessfulBrokerAuthResponse(): SuccessfulBrokerAuthResponse {
  return {
    userId: "",
    brokerCode: "",
    brokerAccountId: "",
    exchanges: [],
    products: [],
    orderTypes: [],
    tradingAccountParameters: [],
  };
}

export const SuccessfulBrokerAuthResponse = {
  encode(message: SuccessfulBrokerAuthResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.brokerCode !== "") {
      writer.uint32(34).string(message.brokerCode);
    }
    if (message.brokerAccountId !== "") {
      writer.uint32(50).string(message.brokerAccountId);
    }
    for (const v of message.exchanges) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.products) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.orderTypes) {
      writer.uint32(98).string(v!);
    }
    for (const v of message.tradingAccountParameters) {
      TradingAccount_TradingAccountParameter.encode(v!, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SuccessfulBrokerAuthResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuccessfulBrokerAuthResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.brokerCode = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.brokerAccountId = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.exchanges.push(reader.string());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.products.push(reader.string());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.orderTypes.push(reader.string());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.tradingAccountParameters.push(TradingAccount_TradingAccountParameter.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SuccessfulBrokerAuthResponse {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      brokerCode: isSet(object.brokerCode) ? globalThis.String(object.brokerCode) : "",
      brokerAccountId: isSet(object.brokerAccountId) ? globalThis.String(object.brokerAccountId) : "",
      exchanges: globalThis.Array.isArray(object?.exchanges)
        ? object.exchanges.map((e: any) => globalThis.String(e))
        : [],
      products: globalThis.Array.isArray(object?.products) ? object.products.map((e: any) => globalThis.String(e)) : [],
      orderTypes: globalThis.Array.isArray(object?.orderTypes)
        ? object.orderTypes.map((e: any) => globalThis.String(e))
        : [],
      tradingAccountParameters: globalThis.Array.isArray(object?.tradingAccountParameters)
        ? object.tradingAccountParameters.map((e: any) => TradingAccount_TradingAccountParameter.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SuccessfulBrokerAuthResponse): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.brokerCode !== "") {
      obj.brokerCode = message.brokerCode;
    }
    if (message.brokerAccountId !== "") {
      obj.brokerAccountId = message.brokerAccountId;
    }
    if (message.exchanges?.length) {
      obj.exchanges = message.exchanges;
    }
    if (message.products?.length) {
      obj.products = message.products;
    }
    if (message.orderTypes?.length) {
      obj.orderTypes = message.orderTypes;
    }
    if (message.tradingAccountParameters?.length) {
      obj.tradingAccountParameters = message.tradingAccountParameters.map((e) =>
        TradingAccount_TradingAccountParameter.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SuccessfulBrokerAuthResponse>, I>>(base?: I): SuccessfulBrokerAuthResponse {
    return SuccessfulBrokerAuthResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SuccessfulBrokerAuthResponse>, I>>(object: I): SuccessfulBrokerAuthResponse {
    const message = createBaseSuccessfulBrokerAuthResponse();
    message.userId = object.userId ?? "";
    message.brokerCode = object.brokerCode ?? "";
    message.brokerAccountId = object.brokerAccountId ?? "";
    message.exchanges = object.exchanges?.map((e) => e) || [];
    message.products = object.products?.map((e) => e) || [];
    message.orderTypes = object.orderTypes?.map((e) => e) || [];
    message.tradingAccountParameters =
      object.tradingAccountParameters?.map((e) => TradingAccount_TradingAccountParameter.fromPartial(e)) || [];
    return message;
  },
};

function createBasePlaceOrModifyOrdersRequest(): PlaceOrModifyOrdersRequest {
  return { tradingAccountId: "", order: [], buyBeforeSell: false };
}

export const PlaceOrModifyOrdersRequest = {
  encode(message: PlaceOrModifyOrdersRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    for (const v of message.order) {
      Order.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.buyBeforeSell !== false) {
      writer.uint32(24).bool(message.buyBeforeSell);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlaceOrModifyOrdersRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaceOrModifyOrdersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.order.push(Order.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.buyBeforeSell = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlaceOrModifyOrdersRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      order: globalThis.Array.isArray(object?.order) ? object.order.map((e: any) => Order.fromJSON(e)) : [],
      buyBeforeSell: isSet(object.buyBeforeSell) ? globalThis.Boolean(object.buyBeforeSell) : false,
    };
  },

  toJSON(message: PlaceOrModifyOrdersRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.order?.length) {
      obj.order = message.order.map((e) => Order.toJSON(e));
    }
    if (message.buyBeforeSell !== false) {
      obj.buyBeforeSell = message.buyBeforeSell;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlaceOrModifyOrdersRequest>, I>>(base?: I): PlaceOrModifyOrdersRequest {
    return PlaceOrModifyOrdersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlaceOrModifyOrdersRequest>, I>>(object: I): PlaceOrModifyOrdersRequest {
    const message = createBasePlaceOrModifyOrdersRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.order = object.order?.map((e) => Order.fromPartial(e)) || [];
    message.buyBeforeSell = object.buyBeforeSell ?? false;
    return message;
  },
};

function createBasePlaceOrModifyOrdersResponse(): PlaceOrModifyOrdersResponse {
  return { orderResponse: [] };
}

export const PlaceOrModifyOrdersResponse = {
  encode(message: PlaceOrModifyOrdersResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.orderResponse) {
      OrderResponse.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlaceOrModifyOrdersResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaceOrModifyOrdersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.orderResponse.push(OrderResponse.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlaceOrModifyOrdersResponse {
    return {
      orderResponse: globalThis.Array.isArray(object?.orderResponse)
        ? object.orderResponse.map((e: any) => OrderResponse.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PlaceOrModifyOrdersResponse): unknown {
    const obj: any = {};
    if (message.orderResponse?.length) {
      obj.orderResponse = message.orderResponse.map((e) => OrderResponse.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlaceOrModifyOrdersResponse>, I>>(base?: I): PlaceOrModifyOrdersResponse {
    return PlaceOrModifyOrdersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlaceOrModifyOrdersResponse>, I>>(object: I): PlaceOrModifyOrdersResponse {
    const message = createBasePlaceOrModifyOrdersResponse();
    message.orderResponse = object.orderResponse?.map((e) => OrderResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCancelOrdersRequest(): CancelOrdersRequest {
  return { tradingAccountId: "", orderId: [] };
}

export const CancelOrdersRequest = {
  encode(message: CancelOrdersRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    for (const v of message.orderId) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CancelOrdersRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancelOrdersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderId.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CancelOrdersRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      orderId: globalThis.Array.isArray(object?.orderId) ? object.orderId.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: CancelOrdersRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.orderId?.length) {
      obj.orderId = message.orderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CancelOrdersRequest>, I>>(base?: I): CancelOrdersRequest {
    return CancelOrdersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CancelOrdersRequest>, I>>(object: I): CancelOrdersRequest {
    const message = createBaseCancelOrdersRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.orderId = object.orderId?.map((e) => e) || [];
    return message;
  },
};

function createBaseCancelOrdersResponse(): CancelOrdersResponse {
  return { orderResponse: [] };
}

export const CancelOrdersResponse = {
  encode(message: CancelOrdersResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.orderResponse) {
      OrderResponse.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CancelOrdersResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancelOrdersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderResponse.push(OrderResponse.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CancelOrdersResponse {
    return {
      orderResponse: globalThis.Array.isArray(object?.orderResponse)
        ? object.orderResponse.map((e: any) => OrderResponse.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CancelOrdersResponse): unknown {
    const obj: any = {};
    if (message.orderResponse?.length) {
      obj.orderResponse = message.orderResponse.map((e) => OrderResponse.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CancelOrdersResponse>, I>>(base?: I): CancelOrdersResponse {
    return CancelOrdersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CancelOrdersResponse>, I>>(object: I): CancelOrdersResponse {
    const message = createBaseCancelOrdersResponse();
    message.orderResponse = object.orderResponse?.map((e) => OrderResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOrderResponse(): OrderResponse {
  return {
    successful: false,
    clientOrderId: "",
    orderId: "",
    brokerOrderId: "",
    errorMessage: "",
    commitOrder: false,
    order: undefined,
  };
}

export const OrderResponse = {
  encode(message: OrderResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.successful !== false) {
      writer.uint32(8).bool(message.successful);
    }
    if (message.clientOrderId !== "") {
      writer.uint32(18).string(message.clientOrderId);
    }
    if (message.orderId !== "") {
      writer.uint32(50).string(message.orderId);
    }
    if (message.brokerOrderId !== "") {
      writer.uint32(26).string(message.brokerOrderId);
    }
    if (message.errorMessage !== "") {
      writer.uint32(34).string(message.errorMessage);
    }
    if (message.commitOrder !== false) {
      writer.uint32(40).bool(message.commitOrder);
    }
    if (message.order !== undefined) {
      Order.encode(message.order, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.successful = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.clientOrderId = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.orderId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.brokerOrderId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.commitOrder = reader.bool();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.order = Order.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderResponse {
    return {
      successful: isSet(object.successful) ? globalThis.Boolean(object.successful) : false,
      clientOrderId: isSet(object.clientOrderId) ? globalThis.String(object.clientOrderId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
      brokerOrderId: isSet(object.brokerOrderId) ? globalThis.String(object.brokerOrderId) : "",
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
      commitOrder: isSet(object.commitOrder) ? globalThis.Boolean(object.commitOrder) : false,
      order: isSet(object.order) ? Order.fromJSON(object.order) : undefined,
    };
  },

  toJSON(message: OrderResponse): unknown {
    const obj: any = {};
    if (message.successful !== false) {
      obj.successful = message.successful;
    }
    if (message.clientOrderId !== "") {
      obj.clientOrderId = message.clientOrderId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    if (message.brokerOrderId !== "") {
      obj.brokerOrderId = message.brokerOrderId;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    if (message.commitOrder !== false) {
      obj.commitOrder = message.commitOrder;
    }
    if (message.order !== undefined) {
      obj.order = Order.toJSON(message.order);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderResponse>, I>>(base?: I): OrderResponse {
    return OrderResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderResponse>, I>>(object: I): OrderResponse {
    const message = createBaseOrderResponse();
    message.successful = object.successful ?? false;
    message.clientOrderId = object.clientOrderId ?? "";
    message.orderId = object.orderId ?? "";
    message.brokerOrderId = object.brokerOrderId ?? "";
    message.errorMessage = object.errorMessage ?? "";
    message.commitOrder = object.commitOrder ?? false;
    message.order = (object.order !== undefined && object.order !== null) ? Order.fromPartial(object.order) : undefined;
    return message;
  },
};

function createBaseGetOrderRequest(): GetOrderRequest {
  return { accountId: "", orderId: "" };
}

export const GetOrderRequest = {
  encode(message: GetOrderRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    if (message.orderId !== "") {
      writer.uint32(26).string(message.orderId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.orderId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
    };
  },

  toJSON(message: GetOrderRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderRequest>, I>>(base?: I): GetOrderRequest {
    return GetOrderRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderRequest>, I>>(object: I): GetOrderRequest {
    const message = createBaseGetOrderRequest();
    message.accountId = object.accountId ?? "";
    message.orderId = object.orderId ?? "";
    return message;
  },
};

function createBaseGetAllOrdersRequest(): GetAllOrdersRequest {
  return { tradingAccountId: "" };
}

export const GetAllOrdersRequest = {
  encode(message: GetAllOrdersRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAllOrdersRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllOrdersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllOrdersRequest {
    return { tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "" };
  },

  toJSON(message: GetAllOrdersRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllOrdersRequest>, I>>(base?: I): GetAllOrdersRequest {
    return GetAllOrdersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllOrdersRequest>, I>>(object: I): GetAllOrdersRequest {
    const message = createBaseGetAllOrdersRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBaseTradingAccountSyncRequest(): TradingAccountSyncRequest {
  return { tradingAccountId: "", types: [], force: false };
}

export const TradingAccountSyncRequest = {
  encode(message: TradingAccountSyncRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    writer.uint32(18).fork();
    for (const v of message.types) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.force !== false) {
      writer.uint32(48).bool(message.force);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountSyncRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountSyncRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag === 16) {
            message.types.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.types.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.force = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountSyncRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      types: globalThis.Array.isArray(object?.types)
        ? object.types.map((e: any) => tradingAccountSyncRequest_TypeFromJSON(e))
        : [],
      force: isSet(object.force) ? globalThis.Boolean(object.force) : false,
    };
  },

  toJSON(message: TradingAccountSyncRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.types?.length) {
      obj.types = message.types.map((e) => tradingAccountSyncRequest_TypeToJSON(e));
    }
    if (message.force !== false) {
      obj.force = message.force;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountSyncRequest>, I>>(base?: I): TradingAccountSyncRequest {
    return TradingAccountSyncRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountSyncRequest>, I>>(object: I): TradingAccountSyncRequest {
    const message = createBaseTradingAccountSyncRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.types = object.types?.map((e) => e) || [];
    message.force = object.force ?? false;
    return message;
  },
};

function createBaseTradingAccountUpdate(): TradingAccountUpdate {
  return { userId: "", tradingAccountId: "", orders: [], positions: [], margin: undefined };
}

export const TradingAccountUpdate = {
  encode(message: TradingAccountUpdate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.tradingAccountId !== "") {
      writer.uint32(18).string(message.tradingAccountId);
    }
    for (const v of message.orders) {
      Order.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.positions) {
      Position1.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    if (message.margin !== undefined) {
      TradingAccountMargin.encode(message.margin, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountUpdate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.orders.push(Order.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.positions.push(Position1.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.margin = TradingAccountMargin.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountUpdate {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      orders: globalThis.Array.isArray(object?.orders) ? object.orders.map((e: any) => Order.fromJSON(e)) : [],
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => Position1.fromJSON(e))
        : [],
      margin: isSet(object.margin) ? TradingAccountMargin.fromJSON(object.margin) : undefined,
    };
  },

  toJSON(message: TradingAccountUpdate): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => Order.toJSON(e));
    }
    if (message.positions?.length) {
      obj.positions = message.positions.map((e) => Position1.toJSON(e));
    }
    if (message.margin !== undefined) {
      obj.margin = TradingAccountMargin.toJSON(message.margin);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountUpdate>, I>>(base?: I): TradingAccountUpdate {
    return TradingAccountUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountUpdate>, I>>(object: I): TradingAccountUpdate {
    const message = createBaseTradingAccountUpdate();
    message.userId = object.userId ?? "";
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.orders = object.orders?.map((e) => Order.fromPartial(e)) || [];
    message.positions = object.positions?.map((e) => Position1.fromPartial(e)) || [];
    message.margin = (object.margin !== undefined && object.margin !== null)
      ? TradingAccountMargin.fromPartial(object.margin)
      : undefined;
    return message;
  },
};

function createBasePosition(): Position {
  return {
    security: undefined,
    product: 0,
    quantity: 0,
    overnightQuantity: 0,
    overnightValue: 0,
    buyQuantity: 0,
    sellQuantity: 0,
    buyValue: 0,
    sellValue: 0,
    dayBuyQuantity: 0,
    dayBuyValue: 0,
    daySellQuantity: 0,
    daySellValue: 0,
  };
}

export const Position = {
  encode(message: Position, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(18).fork()).ldelim();
    }
    if (message.product !== 0) {
      writer.uint32(32).int32(message.product);
    }
    if (message.quantity !== 0) {
      writer.uint32(144).int32(message.quantity);
    }
    if (message.overnightQuantity !== 0) {
      writer.uint32(152).int32(message.overnightQuantity);
    }
    if (message.overnightValue !== 0) {
      writer.uint32(161).double(message.overnightValue);
    }
    if (message.buyQuantity !== 0) {
      writer.uint32(48).int32(message.buyQuantity);
    }
    if (message.sellQuantity !== 0) {
      writer.uint32(64).int32(message.sellQuantity);
    }
    if (message.buyValue !== 0) {
      writer.uint32(81).double(message.buyValue);
    }
    if (message.sellValue !== 0) {
      writer.uint32(97).double(message.sellValue);
    }
    if (message.dayBuyQuantity !== 0) {
      writer.uint32(104).int32(message.dayBuyQuantity);
    }
    if (message.dayBuyValue !== 0) {
      writer.uint32(113).double(message.dayBuyValue);
    }
    if (message.daySellQuantity !== 0) {
      writer.uint32(120).int32(message.daySellQuantity);
    }
    if (message.daySellValue !== 0) {
      writer.uint32(129).double(message.daySellValue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Position {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.product = reader.int32() as any;
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 19:
          if (tag !== 152) {
            break;
          }

          message.overnightQuantity = reader.int32();
          continue;
        case 20:
          if (tag !== 161) {
            break;
          }

          message.overnightValue = reader.double();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.buyQuantity = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.sellQuantity = reader.int32();
          continue;
        case 10:
          if (tag !== 81) {
            break;
          }

          message.buyValue = reader.double();
          continue;
        case 12:
          if (tag !== 97) {
            break;
          }

          message.sellValue = reader.double();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.dayBuyQuantity = reader.int32();
          continue;
        case 14:
          if (tag !== 113) {
            break;
          }

          message.dayBuyValue = reader.double();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.daySellQuantity = reader.int32();
          continue;
        case 16:
          if (tag !== 129) {
            break;
          }

          message.daySellValue = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Position {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      overnightQuantity: isSet(object.overnightQuantity) ? globalThis.Number(object.overnightQuantity) : 0,
      overnightValue: isSet(object.overnightValue) ? globalThis.Number(object.overnightValue) : 0,
      buyQuantity: isSet(object.buyQuantity) ? globalThis.Number(object.buyQuantity) : 0,
      sellQuantity: isSet(object.sellQuantity) ? globalThis.Number(object.sellQuantity) : 0,
      buyValue: isSet(object.buyValue) ? globalThis.Number(object.buyValue) : 0,
      sellValue: isSet(object.sellValue) ? globalThis.Number(object.sellValue) : 0,
      dayBuyQuantity: isSet(object.dayBuyQuantity) ? globalThis.Number(object.dayBuyQuantity) : 0,
      dayBuyValue: isSet(object.dayBuyValue) ? globalThis.Number(object.dayBuyValue) : 0,
      daySellQuantity: isSet(object.daySellQuantity) ? globalThis.Number(object.daySellQuantity) : 0,
      daySellValue: isSet(object.daySellValue) ? globalThis.Number(object.daySellValue) : 0,
    };
  },

  toJSON(message: Position): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.overnightQuantity !== 0) {
      obj.overnightQuantity = Math.round(message.overnightQuantity);
    }
    if (message.overnightValue !== 0) {
      obj.overnightValue = message.overnightValue;
    }
    if (message.buyQuantity !== 0) {
      obj.buyQuantity = Math.round(message.buyQuantity);
    }
    if (message.sellQuantity !== 0) {
      obj.sellQuantity = Math.round(message.sellQuantity);
    }
    if (message.buyValue !== 0) {
      obj.buyValue = message.buyValue;
    }
    if (message.sellValue !== 0) {
      obj.sellValue = message.sellValue;
    }
    if (message.dayBuyQuantity !== 0) {
      obj.dayBuyQuantity = Math.round(message.dayBuyQuantity);
    }
    if (message.dayBuyValue !== 0) {
      obj.dayBuyValue = message.dayBuyValue;
    }
    if (message.daySellQuantity !== 0) {
      obj.daySellQuantity = Math.round(message.daySellQuantity);
    }
    if (message.daySellValue !== 0) {
      obj.daySellValue = message.daySellValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Position>, I>>(base?: I): Position {
    return Position.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Position>, I>>(object: I): Position {
    const message = createBasePosition();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.product = object.product ?? 0;
    message.quantity = object.quantity ?? 0;
    message.overnightQuantity = object.overnightQuantity ?? 0;
    message.overnightValue = object.overnightValue ?? 0;
    message.buyQuantity = object.buyQuantity ?? 0;
    message.sellQuantity = object.sellQuantity ?? 0;
    message.buyValue = object.buyValue ?? 0;
    message.sellValue = object.sellValue ?? 0;
    message.dayBuyQuantity = object.dayBuyQuantity ?? 0;
    message.dayBuyValue = object.dayBuyValue ?? 0;
    message.daySellQuantity = object.daySellQuantity ?? 0;
    message.daySellValue = object.daySellValue ?? 0;
    return message;
  },
};

function createBaseGetTradingAccountPnlRequest(): GetTradingAccountPnlRequest {
  return { accountId: "" };
}

export const GetTradingAccountPnlRequest = {
  encode(message: GetTradingAccountPnlRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTradingAccountPnlRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTradingAccountPnlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTradingAccountPnlRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: GetTradingAccountPnlRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTradingAccountPnlRequest>, I>>(base?: I): GetTradingAccountPnlRequest {
    return GetTradingAccountPnlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTradingAccountPnlRequest>, I>>(object: I): GetTradingAccountPnlRequest {
    const message = createBaseGetTradingAccountPnlRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseTradingAccountPnl(): TradingAccountPnl {
  return { accountId: "", dayProfit: 0, monthProfit: 0 };
}

export const TradingAccountPnl = {
  encode(message: TradingAccountPnl, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.dayProfit !== 0) {
      writer.uint32(16).int32(message.dayProfit);
    }
    if (message.monthProfit !== 0) {
      writer.uint32(24).int32(message.monthProfit);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountPnl {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountPnl();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.dayProfit = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.monthProfit = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountPnl {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      dayProfit: isSet(object.dayProfit) ? globalThis.Number(object.dayProfit) : 0,
      monthProfit: isSet(object.monthProfit) ? globalThis.Number(object.monthProfit) : 0,
    };
  },

  toJSON(message: TradingAccountPnl): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.dayProfit !== 0) {
      obj.dayProfit = Math.round(message.dayProfit);
    }
    if (message.monthProfit !== 0) {
      obj.monthProfit = Math.round(message.monthProfit);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountPnl>, I>>(base?: I): TradingAccountPnl {
    return TradingAccountPnl.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountPnl>, I>>(object: I): TradingAccountPnl {
    const message = createBaseTradingAccountPnl();
    message.accountId = object.accountId ?? "";
    message.dayProfit = object.dayProfit ?? 0;
    message.monthProfit = object.monthProfit ?? 0;
    return message;
  },
};

function createBaseGetHoldingsRequest(): GetHoldingsRequest {
  return { accountId: "" };
}

export const GetHoldingsRequest = {
  encode(message: GetHoldingsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetHoldingsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHoldingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHoldingsRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: GetHoldingsRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHoldingsRequest>, I>>(base?: I): GetHoldingsRequest {
    return GetHoldingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHoldingsRequest>, I>>(object: I): GetHoldingsRequest {
    const message = createBaseGetHoldingsRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseGetHoldingsResponse(): GetHoldingsResponse {
  return { holdings: [] };
}

export const GetHoldingsResponse = {
  encode(message: GetHoldingsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.holdings) {
      Holding.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetHoldingsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHoldingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.holdings.push(Holding.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHoldingsResponse {
    return {
      holdings: globalThis.Array.isArray(object?.holdings) ? object.holdings.map((e: any) => Holding.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetHoldingsResponse): unknown {
    const obj: any = {};
    if (message.holdings?.length) {
      obj.holdings = message.holdings.map((e) => Holding.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHoldingsResponse>, I>>(base?: I): GetHoldingsResponse {
    return GetHoldingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHoldingsResponse>, I>>(object: I): GetHoldingsResponse {
    const message = createBaseGetHoldingsResponse();
    message.holdings = object.holdings?.map((e) => Holding.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHolding(): Holding {
  return { security: undefined, quantity: 0, averageBuyPrice: 0, t1Quantity: 0 };
}

export const Holding = {
  encode(message: Holding, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.quantity !== 0) {
      writer.uint32(16).int32(message.quantity);
    }
    if (message.averageBuyPrice !== 0) {
      writer.uint32(24).int32(message.averageBuyPrice);
    }
    if (message.t1Quantity !== 0) {
      writer.uint32(32).int32(message.t1Quantity);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Holding {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHolding();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.averageBuyPrice = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.t1Quantity = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Holding {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      averageBuyPrice: isSet(object.averageBuyPrice) ? globalThis.Number(object.averageBuyPrice) : 0,
      t1Quantity: isSet(object.t1Quantity) ? globalThis.Number(object.t1Quantity) : 0,
    };
  },

  toJSON(message: Holding): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.averageBuyPrice !== 0) {
      obj.averageBuyPrice = Math.round(message.averageBuyPrice);
    }
    if (message.t1Quantity !== 0) {
      obj.t1Quantity = Math.round(message.t1Quantity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Holding>, I>>(base?: I): Holding {
    return Holding.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Holding>, I>>(object: I): Holding {
    const message = createBaseHolding();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.quantity = object.quantity ?? 0;
    message.averageBuyPrice = object.averageBuyPrice ?? 0;
    message.t1Quantity = object.t1Quantity ?? 0;
    return message;
  },
};

function createBaseGetOrderHistoryRequest(): GetOrderHistoryRequest {
  return { accountId: "", orderId: "" };
}

export const GetOrderHistoryRequest = {
  encode(message: GetOrderHistoryRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.orderId !== "") {
      writer.uint32(18).string(message.orderId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderHistoryRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderHistoryRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
    };
  },

  toJSON(message: GetOrderHistoryRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderHistoryRequest>, I>>(base?: I): GetOrderHistoryRequest {
    return GetOrderHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderHistoryRequest>, I>>(object: I): GetOrderHistoryRequest {
    const message = createBaseGetOrderHistoryRequest();
    message.accountId = object.accountId ?? "";
    message.orderId = object.orderId ?? "";
    return message;
  },
};

function createBaseGetOrderHistoryResponse(): GetOrderHistoryResponse {
  return { orders: [] };
}

export const GetOrderHistoryResponse = {
  encode(message: GetOrderHistoryResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.orders) {
      OrderHistory.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderHistoryResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.orders.push(OrderHistory.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderHistoryResponse {
    return {
      orders: globalThis.Array.isArray(object?.orders) ? object.orders.map((e: any) => OrderHistory.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetOrderHistoryResponse): unknown {
    const obj: any = {};
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => OrderHistory.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderHistoryResponse>, I>>(base?: I): GetOrderHistoryResponse {
    return GetOrderHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderHistoryResponse>, I>>(object: I): GetOrderHistoryResponse {
    const message = createBaseGetOrderHistoryResponse();
    message.orders = object.orders?.map((e) => OrderHistory.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOrderHistory(): OrderHistory {
  return {
    clientOrderId: "",
    orderId: "",
    brokerOrderId: "",
    exchangeOrderId: "",
    security: undefined,
    transactionType: 0,
    orderType: 0,
    quantity: 0,
    product: 0,
    price: 0,
    triggerPrice: 0,
    variety: 0,
    disclosedQuantity: 0,
    validity: 0,
    status: "",
    filledQuantity: 0,
    unfilledQuantity: 0,
    averageTradedPrice: 0,
    secondaryStatus: "",
    exchangeTimestamp: 0,
    message: "",
  };
}

export const OrderHistory = {
  encode(message: OrderHistory, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.clientOrderId !== "") {
      writer.uint32(10).string(message.clientOrderId);
    }
    if (message.orderId !== "") {
      writer.uint32(18).string(message.orderId);
    }
    if (message.brokerOrderId !== "") {
      writer.uint32(26).string(message.brokerOrderId);
    }
    if (message.exchangeOrderId !== "") {
      writer.uint32(34).string(message.exchangeOrderId);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(42).fork()).ldelim();
    }
    if (message.transactionType !== 0) {
      writer.uint32(48).int32(message.transactionType);
    }
    if (message.orderType !== 0) {
      writer.uint32(56).int32(message.orderType);
    }
    if (message.quantity !== 0) {
      writer.uint32(64).int32(message.quantity);
    }
    if (message.product !== 0) {
      writer.uint32(72).int32(message.product);
    }
    if (message.price !== 0) {
      writer.uint32(80).int32(message.price);
    }
    if (message.triggerPrice !== 0) {
      writer.uint32(88).int32(message.triggerPrice);
    }
    if (message.variety !== 0) {
      writer.uint32(96).int32(message.variety);
    }
    if (message.disclosedQuantity !== 0) {
      writer.uint32(104).int32(message.disclosedQuantity);
    }
    if (message.validity !== 0) {
      writer.uint32(112).int32(message.validity);
    }
    if (message.status !== "") {
      writer.uint32(122).string(message.status);
    }
    if (message.filledQuantity !== 0) {
      writer.uint32(128).int32(message.filledQuantity);
    }
    if (message.unfilledQuantity !== 0) {
      writer.uint32(136).int32(message.unfilledQuantity);
    }
    if (message.averageTradedPrice !== 0) {
      writer.uint32(144).int32(message.averageTradedPrice);
    }
    if (message.secondaryStatus !== "") {
      writer.uint32(154).string(message.secondaryStatus);
    }
    if (message.exchangeTimestamp !== 0) {
      writer.uint32(160).int64(message.exchangeTimestamp);
    }
    if (message.message !== "") {
      writer.uint32(170).string(message.message);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderHistory {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderHistory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.clientOrderId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.brokerOrderId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.exchangeOrderId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.transactionType = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.orderType = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.product = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.price = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.triggerPrice = reader.int32();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.variety = reader.int32() as any;
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.disclosedQuantity = reader.int32();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.validity = reader.int32() as any;
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.status = reader.string();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.filledQuantity = reader.int32();
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.unfilledQuantity = reader.int32();
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.averageTradedPrice = reader.int32();
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.secondaryStatus = reader.string();
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.exchangeTimestamp = longToNumber(reader.int64() as Long);
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.message = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderHistory {
    return {
      clientOrderId: isSet(object.clientOrderId) ? globalThis.String(object.clientOrderId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
      brokerOrderId: isSet(object.brokerOrderId) ? globalThis.String(object.brokerOrderId) : "",
      exchangeOrderId: isSet(object.exchangeOrderId) ? globalThis.String(object.exchangeOrderId) : "",
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      transactionType: isSet(object.transactionType) ? transactionTypeFromJSON(object.transactionType) : 0,
      orderType: isSet(object.orderType) ? broker_OrderTypeFromJSON(object.orderType) : 0,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      triggerPrice: isSet(object.triggerPrice) ? globalThis.Number(object.triggerPrice) : 0,
      variety: isSet(object.variety) ? broker_VarietyFromJSON(object.variety) : 0,
      disclosedQuantity: isSet(object.disclosedQuantity) ? globalThis.Number(object.disclosedQuantity) : 0,
      validity: isSet(object.validity) ? validityFromJSON(object.validity) : 0,
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      filledQuantity: isSet(object.filledQuantity) ? globalThis.Number(object.filledQuantity) : 0,
      unfilledQuantity: isSet(object.unfilledQuantity) ? globalThis.Number(object.unfilledQuantity) : 0,
      averageTradedPrice: isSet(object.averageTradedPrice) ? globalThis.Number(object.averageTradedPrice) : 0,
      secondaryStatus: isSet(object.secondaryStatus) ? globalThis.String(object.secondaryStatus) : "",
      exchangeTimestamp: isSet(object.exchangeTimestamp) ? globalThis.Number(object.exchangeTimestamp) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: OrderHistory): unknown {
    const obj: any = {};
    if (message.clientOrderId !== "") {
      obj.clientOrderId = message.clientOrderId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    if (message.brokerOrderId !== "") {
      obj.brokerOrderId = message.brokerOrderId;
    }
    if (message.exchangeOrderId !== "") {
      obj.exchangeOrderId = message.exchangeOrderId;
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.transactionType !== 0) {
      obj.transactionType = transactionTypeToJSON(message.transactionType);
    }
    if (message.orderType !== 0) {
      obj.orderType = broker_OrderTypeToJSON(message.orderType);
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    if (message.price !== 0) {
      obj.price = Math.round(message.price);
    }
    if (message.triggerPrice !== 0) {
      obj.triggerPrice = Math.round(message.triggerPrice);
    }
    if (message.variety !== 0) {
      obj.variety = broker_VarietyToJSON(message.variety);
    }
    if (message.disclosedQuantity !== 0) {
      obj.disclosedQuantity = Math.round(message.disclosedQuantity);
    }
    if (message.validity !== 0) {
      obj.validity = validityToJSON(message.validity);
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.filledQuantity !== 0) {
      obj.filledQuantity = Math.round(message.filledQuantity);
    }
    if (message.unfilledQuantity !== 0) {
      obj.unfilledQuantity = Math.round(message.unfilledQuantity);
    }
    if (message.averageTradedPrice !== 0) {
      obj.averageTradedPrice = Math.round(message.averageTradedPrice);
    }
    if (message.secondaryStatus !== "") {
      obj.secondaryStatus = message.secondaryStatus;
    }
    if (message.exchangeTimestamp !== 0) {
      obj.exchangeTimestamp = Math.round(message.exchangeTimestamp);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderHistory>, I>>(base?: I): OrderHistory {
    return OrderHistory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderHistory>, I>>(object: I): OrderHistory {
    const message = createBaseOrderHistory();
    message.clientOrderId = object.clientOrderId ?? "";
    message.orderId = object.orderId ?? "";
    message.brokerOrderId = object.brokerOrderId ?? "";
    message.exchangeOrderId = object.exchangeOrderId ?? "";
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.transactionType = object.transactionType ?? 0;
    message.orderType = object.orderType ?? 0;
    message.quantity = object.quantity ?? 0;
    message.product = object.product ?? 0;
    message.price = object.price ?? 0;
    message.triggerPrice = object.triggerPrice ?? 0;
    message.variety = object.variety ?? 0;
    message.disclosedQuantity = object.disclosedQuantity ?? 0;
    message.validity = object.validity ?? 0;
    message.status = object.status ?? "";
    message.filledQuantity = object.filledQuantity ?? 0;
    message.unfilledQuantity = object.unfilledQuantity ?? 0;
    message.averageTradedPrice = object.averageTradedPrice ?? 0;
    message.secondaryStatus = object.secondaryStatus ?? "";
    message.exchangeTimestamp = object.exchangeTimestamp ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseGetOrderTradeHistoryRequest(): GetOrderTradeHistoryRequest {
  return { accountId: "", orderId: "" };
}

export const GetOrderTradeHistoryRequest = {
  encode(message: GetOrderTradeHistoryRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.orderId !== "") {
      writer.uint32(18).string(message.orderId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderTradeHistoryRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderTradeHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderTradeHistoryRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
    };
  },

  toJSON(message: GetOrderTradeHistoryRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderTradeHistoryRequest>, I>>(base?: I): GetOrderTradeHistoryRequest {
    return GetOrderTradeHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderTradeHistoryRequest>, I>>(object: I): GetOrderTradeHistoryRequest {
    const message = createBaseGetOrderTradeHistoryRequest();
    message.accountId = object.accountId ?? "";
    message.orderId = object.orderId ?? "";
    return message;
  },
};

function createBaseGetOrderTradeHistoryResponse(): GetOrderTradeHistoryResponse {
  return { trades: [] };
}

export const GetOrderTradeHistoryResponse = {
  encode(message: GetOrderTradeHistoryResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.trades) {
      Trade.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderTradeHistoryResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderTradeHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trades.push(Trade.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderTradeHistoryResponse {
    return { trades: globalThis.Array.isArray(object?.trades) ? object.trades.map((e: any) => Trade.fromJSON(e)) : [] };
  },

  toJSON(message: GetOrderTradeHistoryResponse): unknown {
    const obj: any = {};
    if (message.trades?.length) {
      obj.trades = message.trades.map((e) => Trade.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderTradeHistoryResponse>, I>>(base?: I): GetOrderTradeHistoryResponse {
    return GetOrderTradeHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderTradeHistoryResponse>, I>>(object: I): GetOrderTradeHistoryResponse {
    const message = createBaseGetOrderTradeHistoryResponse();
    message.trades = object.trades?.map((e) => Trade.fromPartial(e)) || [];
    return message;
  },
};

export interface TradingAccountService {
  GetBrokers(request: GetBrokersRequest): Promise<Brokers>;
  GetBrokerLoginUrl(request: GetBrokerLoginUrlRequest): Promise<GetBrokerLoginUrlResponse>;
  ConnectTradingAccount(request: ConnectTradingAccountRequest): Promise<ConnectTradingAccountResponse>;
  ChangePrimaryTradingAccount(request: ChangePrimaryTradingAccountRequest): Promise<TradingAccounts>;
  GetTradingAccounts(request: Empty): Promise<TradingAccounts>;
  GetTradingAccountMargin(request: GetTradingAccountMarginRequest): Promise<TradingAccountMargin>;
  RefreshTradingAccount(request: RefreshTradingAccountRequest): Promise<TradingAccount>;
  RemoveTradingAccount(request: RemoveTradingAccountRequest): Promise<TradingAccounts>;
  GetTradingAccountPnl(request: GetTradingAccountPnlRequest): Promise<TradingAccountPnl>;
  GetUsersForTradingAccountAdmin(request: GetUsersForTradingAccountRequest): Promise<GetUsersForTradingAccountResponse>;
  SetDebugForTradingAccountAdmin(request: SetDebugForTradingAccountRequest): Promise<Empty>;
  CalculateMargin(request: MarginFromBrokerRequest): Promise<MarginFromBrokerResponse>;
  CalculateMarginWithoutUser(request: MarginFromBrokerRequest): Promise<MarginFromBrokerResponse>;
  SyncTradingAccountMargin(request: GetTradingAccountMarginRequest): Promise<TradingAccountMargin>;
  SyncTradingAccount(request: TradingAccountSyncRequest): Promise<Empty>;
}

export const TradingAccountServiceServiceName = "com.tick2trade.api.tradingbridge.TradingAccountService";
export class TradingAccountServiceClientImpl implements TradingAccountService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TradingAccountServiceServiceName;
    this.rpc = rpc;
    this.GetBrokers = this.GetBrokers.bind(this);
    this.GetBrokerLoginUrl = this.GetBrokerLoginUrl.bind(this);
    this.ConnectTradingAccount = this.ConnectTradingAccount.bind(this);
    this.ChangePrimaryTradingAccount = this.ChangePrimaryTradingAccount.bind(this);
    this.GetTradingAccounts = this.GetTradingAccounts.bind(this);
    this.GetTradingAccountMargin = this.GetTradingAccountMargin.bind(this);
    this.RefreshTradingAccount = this.RefreshTradingAccount.bind(this);
    this.RemoveTradingAccount = this.RemoveTradingAccount.bind(this);
    this.GetTradingAccountPnl = this.GetTradingAccountPnl.bind(this);
    this.GetUsersForTradingAccountAdmin = this.GetUsersForTradingAccountAdmin.bind(this);
    this.SetDebugForTradingAccountAdmin = this.SetDebugForTradingAccountAdmin.bind(this);
    this.CalculateMargin = this.CalculateMargin.bind(this);
    this.CalculateMarginWithoutUser = this.CalculateMarginWithoutUser.bind(this);
    this.SyncTradingAccountMargin = this.SyncTradingAccountMargin.bind(this);
    this.SyncTradingAccount = this.SyncTradingAccount.bind(this);
  }
  GetBrokers(request: GetBrokersRequest): Promise<Brokers> {
    const data = GetBrokersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetBrokers", data);
    return promise.then((data) => Brokers.decode(_m0.Reader.create(data)));
  }

  GetBrokerLoginUrl(request: GetBrokerLoginUrlRequest): Promise<GetBrokerLoginUrlResponse> {
    const data = GetBrokerLoginUrlRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetBrokerLoginUrl", data);
    return promise.then((data) => GetBrokerLoginUrlResponse.decode(_m0.Reader.create(data)));
  }

  ConnectTradingAccount(request: ConnectTradingAccountRequest): Promise<ConnectTradingAccountResponse> {
    const data = ConnectTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ConnectTradingAccount", data);
    return promise.then((data) => ConnectTradingAccountResponse.decode(_m0.Reader.create(data)));
  }

  ChangePrimaryTradingAccount(request: ChangePrimaryTradingAccountRequest): Promise<TradingAccounts> {
    const data = ChangePrimaryTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ChangePrimaryTradingAccount", data);
    return promise.then((data) => TradingAccounts.decode(_m0.Reader.create(data)));
  }

  GetTradingAccounts(request: Empty): Promise<TradingAccounts> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetTradingAccounts", data);
    return promise.then((data) => TradingAccounts.decode(_m0.Reader.create(data)));
  }

  GetTradingAccountMargin(request: GetTradingAccountMarginRequest): Promise<TradingAccountMargin> {
    const data = GetTradingAccountMarginRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetTradingAccountMargin", data);
    return promise.then((data) => TradingAccountMargin.decode(_m0.Reader.create(data)));
  }

  RefreshTradingAccount(request: RefreshTradingAccountRequest): Promise<TradingAccount> {
    const data = RefreshTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RefreshTradingAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  RemoveTradingAccount(request: RemoveTradingAccountRequest): Promise<TradingAccounts> {
    const data = RemoveTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveTradingAccount", data);
    return promise.then((data) => TradingAccounts.decode(_m0.Reader.create(data)));
  }

  GetTradingAccountPnl(request: GetTradingAccountPnlRequest): Promise<TradingAccountPnl> {
    const data = GetTradingAccountPnlRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetTradingAccountPnl", data);
    return promise.then((data) => TradingAccountPnl.decode(_m0.Reader.create(data)));
  }

  GetUsersForTradingAccountAdmin(
    request: GetUsersForTradingAccountRequest,
  ): Promise<GetUsersForTradingAccountResponse> {
    const data = GetUsersForTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetUsersForTradingAccountAdmin", data);
    return promise.then((data) => GetUsersForTradingAccountResponse.decode(_m0.Reader.create(data)));
  }

  SetDebugForTradingAccountAdmin(request: SetDebugForTradingAccountRequest): Promise<Empty> {
    const data = SetDebugForTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetDebugForTradingAccountAdmin", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }

  CalculateMargin(request: MarginFromBrokerRequest): Promise<MarginFromBrokerResponse> {
    const data = MarginFromBrokerRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CalculateMargin", data);
    return promise.then((data) => MarginFromBrokerResponse.decode(_m0.Reader.create(data)));
  }

  CalculateMarginWithoutUser(request: MarginFromBrokerRequest): Promise<MarginFromBrokerResponse> {
    const data = MarginFromBrokerRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CalculateMarginWithoutUser", data);
    return promise.then((data) => MarginFromBrokerResponse.decode(_m0.Reader.create(data)));
  }

  SyncTradingAccountMargin(request: GetTradingAccountMarginRequest): Promise<TradingAccountMargin> {
    const data = GetTradingAccountMarginRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SyncTradingAccountMargin", data);
    return promise.then((data) => TradingAccountMargin.decode(_m0.Reader.create(data)));
  }

  SyncTradingAccount(request: TradingAccountSyncRequest): Promise<Empty> {
    const data = TradingAccountSyncRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SyncTradingAccount", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }
}

export interface OrderService {
  PlaceOrModifyOrders(request: PlaceOrModifyOrdersRequest): Promise<PlaceOrModifyOrdersResponse>;
  CancelOrders(request: CancelOrdersRequest): Promise<CancelOrdersResponse>;
  GetOrder(request: GetOrderRequest): Promise<Order>;
  GetAllOrders(request: GetAllOrdersRequest): Promise<Orders>;
  SyncOrders(request: TradingAccountSyncRequest): Promise<Empty>;
  GetHoldings(request: GetHoldingsRequest): Promise<GetHoldingsResponse>;
  GetAllOrdersAdmin(request: GetAllOrdersRequest): Promise<Orders>;
  GetOrderHistory(request: GetOrderHistoryRequest): Promise<GetOrderHistoryResponse>;
  GetOrderTradeHistory(request: GetOrderTradeHistoryRequest): Promise<GetOrderTradeHistoryResponse>;
}

export const OrderServiceServiceName = "com.tick2trade.api.tradingbridge.OrderService";
export class OrderServiceClientImpl implements OrderService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || OrderServiceServiceName;
    this.rpc = rpc;
    this.PlaceOrModifyOrders = this.PlaceOrModifyOrders.bind(this);
    this.CancelOrders = this.CancelOrders.bind(this);
    this.GetOrder = this.GetOrder.bind(this);
    this.GetAllOrders = this.GetAllOrders.bind(this);
    this.SyncOrders = this.SyncOrders.bind(this);
    this.GetHoldings = this.GetHoldings.bind(this);
    this.GetAllOrdersAdmin = this.GetAllOrdersAdmin.bind(this);
    this.GetOrderHistory = this.GetOrderHistory.bind(this);
    this.GetOrderTradeHistory = this.GetOrderTradeHistory.bind(this);
  }
  PlaceOrModifyOrders(request: PlaceOrModifyOrdersRequest): Promise<PlaceOrModifyOrdersResponse> {
    const data = PlaceOrModifyOrdersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "PlaceOrModifyOrders", data);
    return promise.then((data) => PlaceOrModifyOrdersResponse.decode(_m0.Reader.create(data)));
  }

  CancelOrders(request: CancelOrdersRequest): Promise<CancelOrdersResponse> {
    const data = CancelOrdersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CancelOrders", data);
    return promise.then((data) => CancelOrdersResponse.decode(_m0.Reader.create(data)));
  }

  GetOrder(request: GetOrderRequest): Promise<Order> {
    const data = GetOrderRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetOrder", data);
    return promise.then((data) => Order.decode(_m0.Reader.create(data)));
  }

  GetAllOrders(request: GetAllOrdersRequest): Promise<Orders> {
    const data = GetAllOrdersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetAllOrders", data);
    return promise.then((data) => Orders.decode(_m0.Reader.create(data)));
  }

  SyncOrders(request: TradingAccountSyncRequest): Promise<Empty> {
    const data = TradingAccountSyncRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SyncOrders", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }

  GetHoldings(request: GetHoldingsRequest): Promise<GetHoldingsResponse> {
    const data = GetHoldingsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetHoldings", data);
    return promise.then((data) => GetHoldingsResponse.decode(_m0.Reader.create(data)));
  }

  GetAllOrdersAdmin(request: GetAllOrdersRequest): Promise<Orders> {
    const data = GetAllOrdersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetAllOrdersAdmin", data);
    return promise.then((data) => Orders.decode(_m0.Reader.create(data)));
  }

  GetOrderHistory(request: GetOrderHistoryRequest): Promise<GetOrderHistoryResponse> {
    const data = GetOrderHistoryRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetOrderHistory", data);
    return promise.then((data) => GetOrderHistoryResponse.decode(_m0.Reader.create(data)));
  }

  GetOrderTradeHistory(request: GetOrderTradeHistoryRequest): Promise<GetOrderTradeHistoryResponse> {
    const data = GetOrderTradeHistoryRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetOrderTradeHistory", data);
    return promise.then((data) => GetOrderTradeHistoryResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
